import { gql } from '@apollo/client';
import { agencyItemsFragment } from '../fragments/agencyItems';
import { itemsFragment } from '../fragments/items';

export const getInitialItems = gql`
  query InitialItems($first: Int) {
    residences(limit: 4, sort: RANDOM) {
      id
      name
      price {
        perSqm
        total {
          minimum
        }
        currency
      }
      address
      shortAddress
      deadline
      coverUrl
      path
      metroName
      companyName
    }
    agencies(first: 16, sort: RANDOM) {
      edges {
        node {
          items(limit: 1, sort: RANDOM) {
            ...agencyItemFields
          }
        }
      }
    }
    featuredItems: itemsConnection(filter: { scope: FEATURED }, first: $first) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...itemFields
        }
      }
    }
  }
  ${agencyItemsFragment}
  ${itemsFragment}
`;
